import { Cohort } from 'nove8/constants/root-constants'
import { AMPLITUDE_API_KEY, AMPLITUDE_API_KEY_WOOFY } from 'root-constants'

export const getAmplitudeApiKey = (cohort: Cohort): string =>
  cohort === Cohort.WOOFZ_WOOFY1 ? AMPLITUDE_API_KEY_WOOFY : AMPLITUDE_API_KEY
